import React, { Fragment, useCallback, useMemo } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Accordion, Stack } from '@mantine/core';
import { useLocalStorage } from '@mantine/hooks';

import Link from './Link';
import StyledAccordion from './StyledAccordion';
import useNavList from './useNavList';

const NAV_STYLE = {
    height: '100%',
    overflow: 'auto',
    paddingBottom: '92px',
};

export default function Navigation({ basePath, currentProject, aclEndpoints }) {
    const [accordeonValue, setAccordeonValue] = useLocalStorage({ key: 'content-nav-accordion', defaultValue: [] });

    const availableEndpoints = useMemo(() => {
        if (!aclEndpoints) {
            return [];
        }

        return Object.keys(aclEndpoints).filter(
            (endpoint) => aclEndpoints[endpoint],
        );
    }, [aclEndpoints]);

    const { navList } = useNavList({ basePath, currentProject, availableEndpoints });

    const handleAccordeonChange = useCallback((newSate) => {
        setAccordeonValue(newSate);
    }, []);

    if (!availableEndpoints.length) {
        return null;
    }

    return (
        <div style={NAV_STYLE}>
            <StyledAccordion
                multiple
                id="nav-accordion"
                value={accordeonValue}
                onChange={handleAccordeonChange}
            >
                {navList.map((category) => (
                    <Accordion.Item key={category.title} value={category.title}>
                        <Accordion.Control>
                            {category.title}
                        </Accordion.Control>
                        <Accordion.Panel>
                            <Stack spacing={0} justify="flex-start">
                                {category.sections?.map((section, i) => (
                                    <Fragment key={section.label || section.icon || i}>
                                        {!!section.label && (
                                            <span key={section.label} className="c-nav-link-subtitle">
                                                <FontAwesomeIcon icon={section.icon} />
                                                {section.label}
                                            </span>
                                        )}
                                        {section.items?.map((link) => (
                                            <Link key={link.href} to={link.href}>
                                                {link.label}
                                            </Link>
                                        ))}
                                    </Fragment>
                                ))}
                            </Stack>
                        </Accordion.Panel>
                    </Accordion.Item>
                ))}
            </StyledAccordion>
        </div>
    );
}
